<script setup>
import { inject } from 'vue'

import { errorsKey, fieldNameKey } from './symbols'

const errors = inject(errorsKey)
const fieldName = inject(fieldNameKey)
</script>

<template>
  <BaseFormError :errors="errors[fieldName]" />
</template>
